var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tabs',{staticClass:"nav-tabs"},_vm._l((_vm.routes),function(route){return _c('b-tab',{key:route.label,attrs:{"title":route.label},on:{"click":function($event){_vm.changeTab(route)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }